export const lineHeightTokens = {
    smallest: '15px',
    small: '20px',
    medium: '22px',
    large: '24px',
    larger: '32px',
    largest: '48px'
};
